const DATA_ATTR = 'data-note';
const CLASS_PREFIX = 'note';

const $container = document.querySelector(`[${DATA_ATTR}]`);

if ($container) note($container);

export function note($container) {

    const $descriptionHeader = $container.querySelector(`[${DATA_ATTR}-description-header]`);
    const $descriptionBody = $container.querySelector(`[${DATA_ATTR}-description-body]`);
    const $descriptionHeaderIcon = $container.querySelector(`[${DATA_ATTR}-description-header-icon]`);
    init()

    function init(){
        $descriptionHeader.addEventListener('click', () => {
            $descriptionBody.classList.toggle('open');
            $descriptionHeaderIcon.classList.toggle('open');
        })
    }

}
